var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.getDataList(1);
      }
    }
  }, [_c('div', {
    staticClass: "flex-row jcsb"
  }, [_c('el-form-item', [_vm.isAuth('sys:promotion:save') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Promotion")]) : _vm._e()], 1)], 1)])], 1), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "680",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "header-align": "center",
      "align": "center",
      "label": "Promotion Code"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "header-align": "center",
      "align": "center",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.enabled == 0 ? _c('el-tag', {
          attrs: {
            "size": "samll",
            "type": "danger"
          }
        }, [_vm._v("Disable")]) : _vm._e(), scope.row.enabled == 1 ? _c('el-tag', {
          attrs: {
            "size": "samll"
          }
        }, [_vm._v("Enable")]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "header-align": "center",
      "align": "center",
      "label": "Remark"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "header-align": "center",
      "align": "center",
      "label": "Create Time"
    }
  }), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "header-align": "center",
      "align": "center",
      "width": "180",
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.isAuth('sys:promotion:disable') && scope.row.enabled == 1 ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.enableOrDisableHandle(scope.row.id, 0);
            }
          }
        }, [_vm._v(" Disable ")]) : _vm._e(), _vm.isAuth('sys:promotion:enable') && scope.row.enabled == 0 ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.enableOrDisableHandle(scope.row.id, 1);
            }
          }
        }, [_vm._v(" Enable ")]) : _vm._e(), _vm.isAuth('sys:promotion:delete') ? _c('el-button', {
          staticClass: "ml0 fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteHandle(scope.row.id);
            }
          }
        }, [_vm._v("Delete")]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  }), _vm.addOrUpdateVisible ? _c('add-or-update', {
    ref: "addOrUpdate",
    on: {
      "refreshDataList": _vm.getDataList
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }